document.addEventListener('DOMContentLoaded', function () {

  const root = document.querySelector('.tg-designer');
  if (!root) return;

  const board = root.querySelector('.tg-board');
  const trash = root.querySelector('.tg-trash');

  if (!board) return;


  /* =========================================
     MOBILE LIBRARY LAYOUT
  ========================================= */

  function setupMobileLibraryTracks() {

    const sidebar = root.querySelector('.tg-sidebar');

    if (!sidebar) return;


    let pieceTrack =
      sidebar.querySelector(
        ':scope > .tg-mobile-piece-track'
      );


    if (!pieceTrack) {

      pieceTrack =
        document.createElement('div');

      pieceTrack.className =
        'tg-mobile-piece-track';


      const directPieces =
        Array.from(sidebar.children)
          .filter(function (child) {

            return (
              child.classList &&
              child.classList.contains(
                'tg-palette-piece'
              )
            );

          });


      if (directPieces.length) {

        const obstaclePalette =
          sidebar.querySelector(
            ':scope > .tg-obstacle-palette'
          );


        if (obstaclePalette) {

          obstaclePalette.insertAdjacentElement(
            'afterend',
            pieceTrack
          );

        } else {

          sidebar.appendChild(pieceTrack);

        }


        directPieces.forEach(function (piece) {

          pieceTrack.appendChild(piece);

        });

      }

    }

  }


  setupMobileLibraryTracks();


  let selectedPiece = null;
  let selectedTile = null;
  let selectedObstacleLength = null;

  let holdTimer = null;
  let longPressTriggered = false;

  let mobileHeightBoostId = 1;


  function isMobile() {

    return window.innerWidth <= 749;

  }


  function getPalettePieces() {

    return Array.from(
      root.querySelectorAll(
        '.tg-palette-piece'
      )
    );

  }


  function getObstacleCards() {

    return Array.from(
      root.querySelectorAll(
        '.tg-obstacle-card'
      )
    );

  }


  function updateMobileCount() {

    const count =
      board.querySelectorAll(
        '.tg-placed'
      ).length;


    const countElement =
      root.querySelector('.tg-count');


    if (countElement) {

      countElement.textContent = count;

    }


    const cartButton =
      root.querySelector('.tg-cart');


    if (cartButton) {

      cartButton.disabled = count === 0;

    }

  }


  function clearPieceSelection() {

    getPalettePieces()
      .forEach(function (piece) {

        piece.classList.remove(
          'tg-mobile-selected'
        );

      });

  }


  function clearObstacleSelection() {

    getObstacleCards()
      .forEach(function (card) {

        card.classList.remove(
          'is-selected'
        );

      });

  }


  function clearSelectedTile() {

    board
      .querySelectorAll(
        '.tg-mobile-tile-selected'
      )
      .forEach(function (tile) {

        tile.classList.remove(
          'tg-mobile-tile-selected'
        );

      });


    selectedTile = null;

  }


  function selectTile(tile) {

    clearSelectedTile();

    selectedTile = tile;

    tile.classList.add(
      'tg-mobile-tile-selected'
    );

  }


  function clearPlacementChoice() {

    selectedPiece = null;
    selectedObstacleLength = null;

    clearPieceSelection();
    clearObstacleSelection();

  }


  /* =========================================
     HEIGHT BOOST
  ========================================= */


  function getCells() {

    return Array.from(
      board.querySelectorAll(
        '.tg-cell'
      )
    );

  }


  function getGridSize() {

    return Math.round(
      Math.sqrt(
        getCells().length
      )
    );

  }


  function getCellInfo(cell) {

    const cells = getCells();

    const index =
      cells.indexOf(cell);


    if (index < 0) return null;


    const size = getGridSize();


    return {

      index: index,

      row:
        Math.floor(
          index / size
        ),

      col:
        index % size,

      size: size,

      cells: cells

    };

  }


  function secondCellDown(firstCell) {

    const info =
      getCellInfo(firstCell);


    if (
      !info ||
      info.row >= info.size - 1
    ) {

      return null;

    }


    return info.cells[
      (info.row + 1) *
      info.size +
      info.col
    ];

  }


  function cellIsFree(cell) {

    return !!(
      cell &&
      !cell.querySelector(
        ':scope > .tg-placed'
      )
    );

  }


  function createHeightBoostHalf(
    type,
    id,
    first
  ) {

    const tile =
      document.createElement('div');


    tile.className =
      'tg-placed ' +
      'tg-heightboost-half ' +
      (
        first
          ? 'tg-heightboost-first'
          : 'tg-heightboost-second'
      );


    tile.dataset.piece = type;

    tile.dataset.heightboostId = id;

    tile.dataset.heightboostDirection =
      'down';

    tile.dataset.rotation = '0';

    tile.draggable = true;

    tile.style.transform =
      'rotate(0deg)';


    const platform =
      document.createElement('span');


    platform.className =
      'tg-hb-platform-cover';


    tile.appendChild(platform);


    return tile;

  }


  function positionMobileHeightSlot(
    slot,
    firstCell
  ) {

    const info =
      getCellInfo(firstCell);


    if (!info) return;


    const unit =
      100 / info.size;


    slot.style.left =
      (
        info.col *
        unit
      ) + '%';


    slot.style.top =
      (
        (
          info.row +
          0.5
        ) *
        unit
      ) + '%';


    slot.style.width =
      unit + '%';


    slot.style.height =
      unit + '%';

  }


  function placeMobileHeightBoost(
    firstCell
  ) {

    const secondCell =
      secondCellDown(firstCell);


    if (
      !cellIsFree(firstCell) ||
      !cellIsFree(secondCell)
    ) {

      if (navigator.vibrate) {

        navigator.vibrate(25);

      }


      return false;

    }


    const id =
      'mobile-hb-' +
      Date.now() +
      '-' +
      mobileHeightBoostId++;


    const first =
      createHeightBoostHalf(
        'heightboost-up',
        id,
        true
      );


    const second =
      createHeightBoostHalf(
        'heightboost-down',
        id,
        false
      );


    firstCell.appendChild(first);

    secondCell.appendChild(second);


    const slot =
      document.createElement('div');


    slot.className =
      'tg-height-slot tg-height-empty';


    slot.dataset.heightboostId = id;


    board.appendChild(slot);


    positionMobileHeightSlot(
      slot,
      firstCell
    );


    updateMobileCount();


    requestAnimationFrame(function () {

      window.dispatchEvent(
        new Event('resize')
      );

    });


    return true;

  }


  function makeMountedPiece(type) {

    const mounted =
      document.createElement('div');


    mounted.className =
      'tg-placed tg-height-mounted';


    mounted.dataset.piece = type;

    mounted.dataset.rotation = '0';

    mounted.draggable = false;

    mounted.style.transform =
      'rotate(0deg)';


    const light =
      document.createElement('span');


    light.className =
      'tg-height-light';


    mounted.appendChild(light);


    return mounted;

  }


  function mountSelectedPiece(slot) {

    if (
      !selectedPiece ||
      selectedPiece === 'heightboost'
    ) {

      return false;

    }


    const oldMounted =
      slot.querySelector(
        ':scope > .tg-height-mounted'
      );


    if (oldMounted) {

      oldMounted.remove();

    }


    const mounted =
      makeMountedPiece(
        selectedPiece
      );


    slot.classList.remove(
      'tg-height-empty'
    );


    slot.appendChild(mounted);


    updateMobileCount();


    return true;

  }


  function removeHeightBoostGroup(id) {

    if (!id) return;


    board
      .querySelectorAll(
        '[data-heightboost-id="' +
        id +
        '"]'
      )
      .forEach(function (item) {

        item.remove();

      });


    clearSelectedTile();

    updateMobileCount();

  }


  /* =========================================
     MOBILE OBSTACLES
  ========================================= */


  function installMobileObstacle(tile) {

    if (
      !tile ||
      tile.dataset.piece !== 'slot1' ||
      !selectedObstacleLength
    ) {

      return false;

    }


    if (
      window.TG_SlotObstacle &&
      typeof window.TG_SlotObstacle.install ===
      'function'
    ) {

      window.TG_SlotObstacle.install(
        tile,
        selectedObstacleLength,
        0
      );


      return true;

    }


    const existing =
      tile.querySelector(
        ':scope > .tg-slot-obstacle-mounted'
      );


    if (existing) {

      existing.remove();

    }


    const obstacle =
      document.createElement('span');


    obstacle.className =
      'tg-slot-obstacle-mounted';


    obstacle.dataset.obstacleLength =
      String(
        selectedObstacleLength
      );


    obstacle.dataset.obstacleRotation =
      '0';


    obstacle.style.setProperty(
      '--tg-slot-obstacle-rotation',
      '0deg'
    );


    tile.appendChild(obstacle);


    return true;

  }


  /* =========================================
     TAP PIECE
  ========================================= */


  root.addEventListener(
    'click',
    function (event) {

      if (!isMobile()) return;

      if (
        root.classList.contains(
          'tg-view-mode'
        )
      ) {

        return;

      }


      const piece =
        event.target.closest(
          '.tg-palette-piece'
        );


      if (
        !piece ||
        !root.contains(piece)
      ) {

        return;

      }


      event.preventDefault();


      selectedPiece =
        piece.dataset.piece;


      selectedObstacleLength = null;


      clearSelectedTile();

      clearPieceSelection();

      clearObstacleSelection();


      piece.classList.add(
        'tg-mobile-selected'
      );


      if (
        selectedPiece === 'tunnel'
      ) {

        root.dataset.tgAddonSelected =
          'tunnel';

      } else {

        delete root.dataset.tgAddonSelected;

      }

    }
  );


  /* =========================================
     TAP OBSTACLE
  ========================================= */


  root.addEventListener(
    'click',
    function (event) {

      if (!isMobile()) return;

      if (
        root.classList.contains(
          'tg-view-mode'
        )
      ) {

        return;

      }


      const card =
        event.target.closest(
          '.tg-obstacle-card'
        );


      if (!card) return;


      event.preventDefault();

      event.stopPropagation();


      selectedObstacleLength =
        Number(
          card.dataset.obstacleLength ||
          0
        );


      selectedPiece = null;


      clearSelectedTile();

      clearPieceSelection();

      clearObstacleSelection();


      card.classList.add(
        'is-selected'
      );

    },
    true
  );


  /* =========================================
     LONG PRESS DELETE
  ========================================= */


  board.addEventListener(
    'pointerdown',
    function (event) {

      if (!isMobile()) return;

      if (
        root.classList.contains(
          'tg-view-mode'
        )
      ) {

        return;

      }


      const mounted =
        event.target.closest(
          '.tg-height-mounted'
        );


      const half =
        event.target.closest(
          '.tg-heightboost-half'
        );


      const tile =
        event.target.closest(
          '.tg-placed'
        );


      if (
        !mounted &&
        !half &&
        !tile
      ) {

        return;

      }


      longPressTriggered = false;


      holdTimer =
        setTimeout(function () {

          longPressTriggered = true;


          if (mounted) {

            const slot =
              mounted.closest(
                '.tg-height-slot'
              );


            mounted.remove();


            if (slot) {

              slot.classList.add(
                'tg-height-empty'
              );

            }

          }


          else if (half) {

            removeHeightBoostGroup(
              half.dataset.heightboostId
            );

          }


          else if (tile) {

            if (
              selectedTile === tile
            ) {

              selectedTile = null;

            }


            tile.remove();

          }


          updateMobileCount();


          if (navigator.vibrate) {

            navigator.vibrate(40);

          }

        }, 550);

    }
  );


  function cancelHold() {

    if (holdTimer) {

      clearTimeout(holdTimer);

      holdTimer = null;

    }

  }


  board.addEventListener(
    'pointerup',
    cancelHold
  );


  board.addEventListener(
    'pointercancel',
    cancelHold
  );


  board.addEventListener(
    'pointermove',
    cancelHold
  );


  /* =========================================
     TAP GRID
  ========================================= */


  board.addEventListener(
    'click',
    function (event) {

      if (!isMobile()) return;


      if (
        root.classList.contains(
          'tg-view-mode'
        )
      ) {

        return;

      }


      if (longPressTriggered) {

        longPressTriggered = false;

        return;

      }


      const heightSlot =
        event.target.closest(
          '.tg-height-slot'
        );


      if (
        heightSlot &&
        selectedPiece &&
        selectedPiece !== 'heightboost'
      ) {

        event.preventDefault();

        event.stopPropagation();


        mountSelectedPiece(
          heightSlot
        );


        return;

      }


      if (
        event.target.closest(
          '.tg-heightboost-half'
        ) ||
        event.target.closest(
          '.tg-height-mounted'
        ) ||
        event.target.closest(
          '.tg-height-slot'
        )
      ) {

        return;

      }


      const cell =
        event.target.closest(
          '.tg-cell'
        );


      if (!cell) return;


      const existingTile =
        cell.querySelector(
          ':scope > .tg-placed'
        );


      if (
        selectedObstacleLength &&
        existingTile &&
        existingTile.dataset.piece ===
        'slot1'
      ) {

        event.preventDefault();

        event.stopPropagation();


        installMobileObstacle(
          existingTile
        );


        return;

      }


      if (existingTile) {

        if (
          selectedTile !==
          existingTile
        ) {

          selectTile(
            existingTile
          );


          return;

        }


        let rotation =
          Number(
            existingTile.dataset.rotation ||
            0
          );


        rotation =
          (
            rotation +
            90
          ) %
          360;


        existingTile.dataset.rotation =
          rotation;


        existingTile.style.transform =
          'rotate(' +
          rotation +
          'deg)';


        return;

      }


      clearSelectedTile();


      if (!selectedPiece) return;


      if (
        selectedPiece ===
        'heightboost'
      ) {

        event.preventDefault();

        event.stopPropagation();


        const placed =
          placeMobileHeightBoost(
            cell
          );


        if (placed) {

          clearPlacementChoice();

        }


        return;

      }


      const newPiece =
        document.createElement('div');


      newPiece.className =
        'tg-placed';


      newPiece.dataset.piece =
        selectedPiece;


      newPiece.dataset.rotation =
        '0';


      newPiece.draggable = true;


      cell.appendChild(
        newPiece
      );


      updateMobileCount();

    }
  );


  /* =========================================
     DELETE BUTTON
  ========================================= */


  if (trash) {

    trash.addEventListener(
      'click',
      function (event) {

        if (!isMobile()) return;


        if (
          root.classList.contains(
            'tg-view-mode'
          )
        ) {

          return;

        }


        event.preventDefault();


        if (!selectedTile) {

          alert(
            'Tap a course tile first, then tap Delete.'
          );


          return;

        }


        if (
          selectedTile.classList.contains(
            'tg-heightboost-half'
          )
        ) {

          removeHeightBoostGroup(
            selectedTile.dataset.heightboostId
          );


          return;

        }


        selectedTile.remove();

        selectedTile = null;


        updateMobileCount();

      }
    );

  }

});


/* =========================================
   MOBILE PLAY COURSE AUTO ZOOM
========================================= */


document.addEventListener(
  'DOMContentLoaded',
  function () {

    const root =
      document.querySelector(
        '.tg-designer'
      );


    if (!root) return;


    const board =
      root.querySelector(
        '.tg-board'
      );


    const wrap =
      root.querySelector(
        '.tg-board-wrap'
      );


    if (
      !board ||
      !wrap
    ) {

      return;

    }


    function mobileCourseZoom() {

      if (
        window.innerWidth >
        749
      ) {

        return;

      }


      if (
        !root.classList.contains(
          'tg-view-mode'
        )
      ) {

        board.style.removeProperty(
          '--tg-mobile-zoom-size'
        );


        board.style.removeProperty(
          '--tg-mobile-zoom-left'
        );


        board.style.removeProperty(
          '--tg-mobile-zoom-top'
        );


        return;

      }


      const cells =
        Array.from(
          board.querySelectorAll(
            '.tg-cell'
          )
        );


      if (!cells.length) return;


      const gridSize =
        Math.round(
          Math.sqrt(
            cells.length
          )
        );


      let minRow = gridSize;
      let maxRow = -1;

      let minCol = gridSize;
      let maxCol = -1;


      cells.forEach(
        function (cell, index) {

          if (
            !cell.querySelector(
              '.tg-placed'
            )
          ) {

            return;

          }


          const row =
            Math.floor(
              index / gridSize
            );


          const col =
            index % gridSize;


          minRow =
            Math.min(
              minRow,
              row
            );


          maxRow =
            Math.max(
              maxRow,
              row
            );


          minCol =
            Math.min(
              minCol,
              col
            );


          maxCol =
            Math.max(
              maxCol,
              col
            );

        }
      );


      if (
        maxRow < 0 ||
        maxCol < 0
      ) {

        return;

      }


      const courseWidth =
        maxCol -
        minCol +
        1;


      const courseHeight =
        maxRow -
        minRow +
        1;


      const courseSize =
        Math.max(
          courseWidth,
          courseHeight
        );


      const visibleCells =
        Math.min(
          gridSize,
          courseSize +
          1
        );


      const zoom =
        Math.min(
          3,
          Math.max(
            1,
            gridSize /
            visibleCells
          )
        );


      const viewport =
        wrap.clientWidth;


      const boardSize =
        viewport *
        zoom;


      const centerCol =
        (
          minCol +
          maxCol +
          1
        ) /
        2;


      const centerRow =
        (
          minRow +
          maxRow +
          1
        ) /
        2;


      const centerX =
        centerCol /
        gridSize *
        boardSize;


      const centerY =
        centerRow /
        gridSize *
        boardSize;


      const left =
        viewport /
        2 -
        centerX;


      const top =
        viewport /
        2 -
        centerY;


      board.style.setProperty(
        '--tg-mobile-zoom-size',
        boardSize + 'px'
      );


      board.style.setProperty(
        '--tg-mobile-zoom-left',
        left + 'px'
      );


      board.style.setProperty(
        '--tg-mobile-zoom-top',
        top + 'px'
      );


      setTimeout(function () {

        window.dispatchEvent(
          new Event('resize')
        );

      }, 50);

    }


    const observer =
      new MutationObserver(
        function () {

          setTimeout(
            mobileCourseZoom,
            100
          );

        }
      );


    observer.observe(
      root,
      {

        attributes: true,

        attributeFilter: [
          'class'
        ]

      }
    );


    window.addEventListener(
      'resize',
      function () {

        if (
          root.classList.contains(
            'tg-view-mode'
          )
        ) {

          setTimeout(
            mobileCourseZoom,
            100
          );

        }

      }
    );

  }
);